import { render } from "./App.vue?vue&type=template&id=586f8de1"
const script = {}

import exportComponent from "D:\\ARCHIVOS\\PROYECCION SERVIDOR\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__